module.exports = __webpack_public_path__ + "img/lisa_n.8faf543c.png";